export function headerFunc() {
  toggleMenu();
}

/**
 * ハンバーガーメニュー
 */
function toggleMenu() {
  const $hamburger = $('.js-hamburger');
  const $drawer = $('.js-drawer')
  $hamburger.on('click', function() {
    $(this).toggleClass('is-open');
    $drawer.toggleClass('is-open');
    $('.l-header').toggleClass('is-open');
  });
}